import { t } from './i18n';
import { TYPE_LABELS } from './constants';

export const transactionLabel = transaction => t(transaction?.paymentKind === 'cash_withdrawal' ? 'QR Cash Withdrawal' : TYPE_LABELS[transaction?.type] || transaction?.type);

export const transactionDescription = transaction => {
  if (transaction?.paymentKind === 'cash_withdrawal') return t('QR Cash Withdrawal');
  if (!transaction?.paymentId || !transaction.counterpartyName) return transaction?.remarks || '';
  const heading = t(Number(transaction.credit) > 0 ? 'Payment from {{name}}' : 'Payment to {{name}}', { name: transaction.counterpartyName });
  return transaction.description ? `${heading} — ${transaction.description}` : heading;
};